<template>
    <div>
        <!-- aws虚拟机 -->
        <amazon-virtual-machine-detail v-if="this.oldLifecycleResource.platform==0&&this.oldLifecycleResource.lifecycleResourceType==0" ref="amazonVirtualMachine" :amazonResourceApplicationBasicInfoForm="oldLifecycleResource"></amazon-virtual-machine-detail>
        <!-- aws虚拟网络 -->
        <amazon-virtual-network-detail v-if="this.oldLifecycleResource.platform==0&&this.oldLifecycleResource.lifecycleResourceType==1" ref="amazonVirtualNetwork" :amazonResourceApplicationBasicInfoForm="oldLifecycleResource"></amazon-virtual-network-detail>
        <!-- aws对象存储 -->
        <amazon-object-storage-detail v-if="this.oldLifecycleResource.platform==0&&this.oldLifecycleResource.lifecycleResourceType==2" ref="amazonObjectStorage" :amazonResourceApplicationBasicInfoForm="oldLifecycleResource"></amazon-object-storage-detail>
        <!-- aws托管数据库 -->
        <amazon-managed-database-detail v-if="this.oldLifecycleResource.platform==0&&this.oldLifecycleResource.lifecycleResourceType==3" ref="amazonManagedDatabase" :amazonResourceApplicationBasicInfoForm="oldLifecycleResource"></amazon-managed-database-detail>
        <!-- aws弹性IP -->
        <amazon-elastic-address-detail v-if="this.oldLifecycleResource.platform==0&&this.oldLifecycleResource.lifecycleResourceType==4" ref="amazonElasticAddress" :amazonResourceApplicationBasicInfoForm="oldLifecycleResource"></amazon-elastic-address-detail>

        <!-- azure虚拟机 -->
        <azure-virtual-machine-detail v-if="this.oldLifecycleResource.platform==2&&this.oldLifecycleResource.lifecycleResourceType==0" ref="azureVirtualMachine" :azureResourceApplicationBasicInfoForm="oldLifecycleResource"></azure-virtual-machine-detail>
        <!-- azure虚拟网络 -->
        <azure-virtual-network-detail v-if="this.oldLifecycleResource.platform==2&&this.oldLifecycleResource.lifecycleResourceType==1" ref="azureVirtualNetwork" :azureResourceApplicationBasicInfoForm="oldLifecycleResource"></azure-virtual-network-detail>
        <!-- azure对象存储 -->
        <azure-object-storage-detail v-if="this.oldLifecycleResource.platform==2&&this.oldLifecycleResource.lifecycleResourceType==2" ref="azureObjectStorage" :azureResourceApplicationBasicInfoForm="oldLifecycleResource"></azure-object-storage-detail>
        <!-- azure托管数据库 -->
        <azure-managed-database-detail v-if="this.oldLifecycleResource.platform==2&&(this.oldLifecycleResource.lifecycleResourceType==5||this.oldLifecycleResource.lifecycleResourceType==6||this.oldLifecycleResource.lifecycleResourceType==7)" ref="azureManagedDatabase" :azureResourceApplicationBasicInfoForm="oldLifecycleResource"></azure-managed-database-detail>
        <!-- azure弹性IP -->
        <azure-elastic-address-detail v-if="this.oldLifecycleResource.platform==2&&this.oldLifecycleResource.lifecycleResourceType==4"
        ref="azureElasticAddress" :azureResourceApplicationBasicInfoForm="oldLifecycleResource"></azure-elastic-address-detail>

        <!-- 资源配置 -->
        <Row :gutter="10" style="margin-bottom: 10px;">
            <Col span="24">
                <Card>
                    <p slot="title" style="line-height: 16px;font-size:13px;color:#000;height: 15px;">{{$t('resourceLifecycle.resourceRecycleInfo')}}</p>
                    <Row style="margin-bottom: 10px;">
                        <Col span="11">
                            <FormItem :label="$t('resourceLifecycle.process')">
                                <span style="width: 200px;">{{process}}</span>
                            </FormItem>
                        </Col>
                    </Row>

                    <Row style="margin-bottom: 10px;">
                        <Col span="11">
                            <FormItem :label="$t('resourceLifecycle.resourceReturnOrRecycleReason')">
                                <span style="width: 200px;">{{describe}}</span>
                            </FormItem>
                        </Col>
                    </Row>

                    <Row>
                        <Col span="22">
                            <FormItem :label="$t('resourceLifecycle.attachment')" prop="enclosure">
                                <Table :no-data-text="$t('common.noData')" border :columns="columnsFile" :data="fileData" :border="false">
                                    <template slot-scope="{row,index}" slot="download">
                                        <!-- 下载 -->
                                        <Button type="success" :loading="modal_loadings" size="small" @click="downloadFile(row)">{{$t('resourceLifecycle.download')}}</Button>
                                    </template>
                                </Table>
                            </FormItem>
                        </Col>
                    </Row>
                </Card>
            </Col>
        </Row>
    </div>
</template>

<script>
    // AWS
    import AmazonVirtualMachineDetail from "../../resource_lifecycle_management/resource_application/aws/virtual_machine/AmazonVirtualMachineDetail"
    import AmazonVirtualNetworkDetail from "../../resource_lifecycle_management/resource_application/aws/virtual_network/AmazonVirtualNetworkDetail"
    import AmazonObjectStorageDetail from "../../resource_lifecycle_management/resource_application/aws/object_storage/AmazonObjectStorageDetail"
    import AmazonManagedDatabaseDetail from "../../resource_lifecycle_management/resource_application/aws/managed_database/AmazonManagedDatabaseDetail"
    import AmazonElasticAddressDetail from "../../resource_lifecycle_management/resource_application/aws/elastic_ip/AmazonElasticAddressDetail"

    // Azure
    import AzureVirtualMachineDetail from "../../resource_lifecycle_management/resource_application/azure/virtual_machine/AzureVirtualMachineDetail"
    import AzureVirtualNetworkDetail from '../../resource_lifecycle_management/resource_application/azure/virtual_network/AzureVirtualNetworkDetail'
    import AzureObjectStorageDetail from '../../resource_lifecycle_management/resource_application/azure/object_storage/AzureObjectStorageDetail'
    import AzureManagedDatabaseDetail from '../../resource_lifecycle_management/resource_application/azure/managed_database/AzureManagedDatabaseDetail'
    import AzureElasticAddressDetail from '../../resource_lifecycle_management/resource_application/azure/elastic_ip/AzureElasticAddressDetail'

    export default {
        name: 'ResourceRecycleDetail',
        props: ['resourceRecycleDetailForm'],
        components: {
            AmazonVirtualMachineDetail,
            AmazonVirtualNetworkDetail,
            AmazonObjectStorageDetail,
            AmazonManagedDatabaseDetail,
            AmazonElasticAddressDetail,
            AzureVirtualMachineDetail,
            AzureVirtualNetworkDetail,
            AzureObjectStorageDetail,
            AzureManagedDatabaseDetail,
            AzureElasticAddressDetail
        },
        data () {
            return {
                modal_loadings: false,//下载
                lifecycleResource: {},
                oldLifecycleResource: {},
                process: '',
                describe: '',
                columnsFile: [
                {
                    title: this.$t('resourceLifecycle.fileName'),
                    key: 'fileName'
                },
                {
                    title: this.$t("resourceLifecycle.fileType"),
                    key: 'fileType'
                },
                {
                    title: this.$t('common.operation'),
                    slot: 'download',
                    "width": 100
                }],
                fileData:[]
            }
        },
        mounted: function () {
            this.approvalReview();
        },
        methods: {
            // 下载附件
            /************************************************************/
            downloadFile: function(row){
                // 下载附件
                this.modal_loadings = true;
                this.$api.file.downloadFile("id",row.id)
                .then(res => {
                    let aTag = document.createElement('a');
                    let blob = new Blob([res.data],{type: 'text/plain;charset=UTF-8'})
                    aTag.download = row.fileName;　　　　
                    aTag.href = URL.createObjectURL(blob);
                    aTag.click();　　　　　　　　　　　　　　
                    URL.revokeObjectURL(blob);
                    setTimeout(() => {
                        this.modal_loadings = false;
                        this.$Message.success(this.$t("resourceLifecycle.response.downloadSuccess"));
                    }, 1000);
                })
            },
            // 审批详情
            /************************************************************/
            approvalReview: function () {
                this.$api.processTask.approvalReview({
                    "processTaskId": this.resourceRecycleDetailForm.processTaskId
                })
                .then(res => {
                    this.lifecycleResource = res.data.lifecycleResource;
                    this.oldLifecycleResource = res.data.oldLifecycleResource;

                    this.process = this.lifecycleResource.approvalFlow;
                    this.describe = this.lifecycleResource.remark;
                    if (this.lifecycleResource.attachmentList != null && this.lifecycleResource.attachmentList != undefined && this.lifecycleResource.attachmentList.length > 0) {
                      this.fileData = this.lifecycleResource.attachmentList;
                    }
                })
            }
        }
    }
</script>

<style scoped>
    .ivu-form-item {
        margin-bottom: 0px !important;
        vertical-align: top;
        zoom: 1;
    }
</style>





// WEBPACK FOOTER //
// src/components/resource_lifecycle_management/resource_recycle/ResourceRecycleDetail.vue